import { OperatorAccess, PERMISSIONS, can } from '../../../lib/permissions';

/**
 * Los partidos no tienen módulo de permisos propio: van con los de reservas
 * (abrir `booking.view`, crear `booking.create`, apuntar o quitar jugadores
 * `booking.modify` y cancelar `booking.delete`).
 */
export const canManageGamePlayers = (access: OperatorAccess): boolean =>
    can(access, PERMISSIONS.BOOKING.MODIFY);

export const canCancelGame = (access: OperatorAccess): boolean =>
    can(access, PERMISSIONS.BOOKING.DELETE);
